import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { PublicHoliday } from '../../Models/Domains/BusinessDays/PublicHoliday';

declare var IS_RUNNING_IN_APP_POOL;

export class PublicHolidaysByYearsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(years: Array<number>): Promise<Array<PublicHoliday>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Common/PublicHolidaysByYears/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { years: years }

    return AjaxWrapper.get<Array<PublicHoliday>, any>(url, data);
  }
}

